// src/App.js
import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';

import RequireAuth from './auth/RequireAuth';
import { ROLES } from './auth/roles';

// 공개
import Login from './components/Login/Login';
import Landing from './components/Landing/Landing';

// 보호 (기존)
import Calendar from './components/Calendar/Calendar';
import PrescriptionSetting from './components/PrescriptionSetting/PrescriptionSetting';
import Detailprescription from './components/Detailprescription/Detailprescription';
import Attentionspan from './components/Attentionspan/Attentionspan';
import Detailattentionresult from './components/Detailattentionspan/Detailattentionspan';
import Contentresult from './components/Contentresult/Contentresult';
import Detailcontentresult from './components/Detailcontentresult/Detailcontentresult';
import Adminusermanagement from './components/Adminusermanagement/Adminusermanagement';
import Adminuserdetail from './components/Adminuserdetail/Adminuserdetail';
import Apilogs from './components/Apilogs/Apilogs';

// ★  (ADMIN 전용)
import Clinicmanagement from './components/Clinicmanagement/Clinicmanagement';
import Auditlog from './components/Auditlog/Auditlog';
import Adminpasswordchange from './components/Adminpasswordchange/Adminpasswordchange';
import Systemnotification from './components/Systemnotification/Systemnotification';

// 유저계정관리 (clinic에서 사용자계정관리)
import ClinicUserManagement from './components/ClinicUserManagement/Clinicusermanagement';
import ClinicUserInfo from './components/ClinicUserManagement/ClinicUserInfo';
import Clinicprotecmanagemnt from './components/ClinicProtecManagement/Clinicprotecmanagemnt';

function Unauthorized() {
  return (
    <div style={{ padding: 24 }}>
      <h2>접근 권한이 없습니다</h2>
      <Link to="/login">로그인 페이지로 이동</Link>
    </div>
  );
}

function NotFound() {
  return (
    <div style={{ padding: 24 }}>
      <h2>페이지를 찾을 수 없습니다 (404)</h2>
      <Link to="/">메인으로</Link>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      {/* 공개 */}
      <Route path="/landing" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />

      {/* 보호: 여러 역할 허용 (기존 그대로) */}
      <Route
        element={<RequireAuth allowed={[ROLES.CLINIC, ROLES.ADMIN]} />}
      >
        <Route path="/" element={<Calendar />} />
        <Route path="/ps" element={<PrescriptionSetting />} />
        <Route path="/dps/:paramsName" element={<Detailprescription />} />
        <Route path="/attentionspan" element={<Attentionspan />} />
        <Route path="/attention/:paramsIndex" element={<Detailattentionresult />} />
        <Route path="/contentresult" element={<Contentresult />} />
        <Route path="/dcr/:paramsIndex" element={<Detailcontentresult />} />
      </Route>

      {/* 보호: ADMIN 전용 라우트 (신규) */}
      <Route element={<RequireAuth allowed={[ROLES.ADMIN]} />}>
        {/* 경로는 취향대로. /admin/clinics 로 추천 */}
        <Route path="/admin/clinics" element={<Clinicmanagement />} />
        <Route path="/admin/auditlogs" element={<Auditlog />} />
        <Route path="/admin/password-change" element={<Adminpasswordchange />} />
        <Route path="/admin/notification" element={<Systemnotification />} />
      </Route>

      <Route element={<RequireAuth allowed={[ROLES.CLINIC, ROLES.ADMIN]} />}>
        <Route path="/clinic/users" element={<ClinicUserManagement />} />
        <Route path="/clinic/users/:userId/info" element={<ClinicUserInfo />} />
        <Route path="/clinic/protectors" element={<Clinicprotecmanagemnt />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
